var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('field-stop-location',{staticClass:"field-StopLocationVia",attrs:{"type":_vm.type,"texts":_vm.texts,"enable-geo":_vm.enableGeo}})}
var staticRenderFns = []

export { render, staticRenderFns }